module.exports = __webpack_public_path__ + "media/images/social_preview-f3a2a6f63863bb5c365c698949b72bf3.jpg";